import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React__default from 'react';
import ColumnManagerToggle from './ColumnManager/ColumnManagerToggle.js';
import { ColumnManagerProvider } from './ColumnManager/context/ColumnManagerContext.js';

var _excluded = ["columnManager", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var TableToolbarWrapper = function TableToolbarWrapper(_ref) {
  var columnManager = _ref.columnManager,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var allowSorting = columnManager.allowSorting,
    allowPinning = columnManager.allowPinning,
    buttonLocation = columnManager.buttonLocation,
    onColumnDefsChange = columnManager.onColumnDefsChange;
  var dataTestId = props.dataTestId || 'table-advanced';
  if (allowSorting || allowPinning) {
    var toolbarClasses = classnames('C-TableAdvanced__toolbar', _defineProperty({}, "--location-".concat(buttonLocation), buttonLocation));
    return /*#__PURE__*/React__default.createElement(ColumnManagerProvider, {
      columnDefs: props.data.columnDefs,
      onColumnDefsChange: onColumnDefsChange
    }, function (_ref2) {
      var columnDefs = _ref2.columnDefs;
      var data = _objectSpread(_objectSpread({}, props.data), {}, {
        columnDefs: columnDefs
      });
      props = _objectSpread(_objectSpread({}, props), {}, {
        data: data,
        showGrid: props.showGrid || allowPinning
      });
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: toolbarClasses
      }, /*#__PURE__*/React__default.createElement(ColumnManagerToggle, {
        dataTestId: "".concat(dataTestId, "_column_manager"),
        location: buttonLocation,
        allowPinning: allowPinning,
        allowSorting: allowSorting
      })), /*#__PURE__*/React__default.cloneElement(children, props));
    });
  }
  return /*#__PURE__*/React__default.cloneElement(children, props);
};

export { TableToolbarWrapper as default };
